export class UserProfileForm {
  public title: string = "";
  public firstName: string = "";
  public lastName: string = "";
  public company: string = "";
  public telephone: string = "";
  public profilePicKey: string = "";
  public profilePicURL: string = "";
}
